module.exports = {
      id: "email-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#email",
      toString: function () {
        return this.url;
      }
    }